exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.app[data-v-3ea74058] .v-application--wrap {\n    z-index: 0;\n}\n", ""]);

